var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ColumnMetadataOriginItem_1;
import '@symon-ai/wisepipe-common-data'; // force import for JsonSchemaV2
import { Column } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonConverter, JsonSchemaV2, MapConverter } from '@symon-ai/wisepipe-serialize';
import { columnMetadataOriginItemSchemaValidation } from '../validations.generated';
export const columnMetadataOriginItemSchema = {
    $id: 'urn:wisepipe-common-pipe:ColumnMetadataOriginItem',
    type: 'object',
    properties: {
        columns: {
            type: 'object',
            additionalProperties: {
                $ref: 'urn:wisepipe-common-data:Column'
            }
        }
    },
    required: ['columns']
};
// A set of columns for a file that feed into a column in a pipe
let ColumnMetadataOriginItem = ColumnMetadataOriginItem_1 = class ColumnMetadataOriginItem {
    constructor(columns) {
        this.columns = new Map();
        columns.forEach((column) => this.columns.set(column.name, column));
        JSON.validate(this, ColumnMetadataOriginItem_1);
    }
    static merge(items) {
        const mergedCols = [];
        items.forEach((item) => {
            item.columns.forEach((col) => mergedCols.push(col));
        });
        // stores internally a map, so no need to dedupe our merged cols
        return new ColumnMetadataOriginItem_1(mergedCols);
    }
};
__decorate([
    JsonConverter(new MapConverter(Column))
], ColumnMetadataOriginItem.prototype, "columns", void 0);
ColumnMetadataOriginItem = ColumnMetadataOriginItem_1 = __decorate([
    JsonSchemaV2(columnMetadataOriginItemSchema, columnMetadataOriginItemSchemaValidation)
], ColumnMetadataOriginItem);
export { ColumnMetadataOriginItem };
//# sourceMappingURL=columnMetadataOriginItem.js.map